import { locationActions } from "../../actionTypes";

const initialState = {
	locations: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case locationActions.FETCH_LOCATIONS: {
			return action.payload.reset
				? { ...initialState, fetching: true }
				: { ...state, fetching: true };
		}

		case locationActions.FETCH_LOCATIONS_FULFILLED: {
			return state.locations.current_page < action.payload.current_page
				? {
						...state,
						fetching: false,
						fetched: true,
						locations: {
							...action.payload,
							data: state.locations.data
								? [...state.locations.data, ...action.payload.data]
								: action.payload.data,
						},
				  }
				: {
						...state,
						fetching: false,
						fetched: true,
						locations: action.payload,
				  };
		}

		case locationActions.FETCH_LOCATIONS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
